export class WysiwygOptions {

    static options: any = {
        lang: 'de-DE',
        toolbar: [
            // [groupName, [list of button]]
            ['style', ['bold', 'italic', 'underline'/*, 'clear'*/]],
            // ['font', ['strikethrough', 'superscript', 'subscript']],
            ['fontsize', ['fontsize']],
            // ['fontname', ['fontname']],
            // ['color', ['color']],
            ['para', ['ul', 'ol' /*'paragraph'*/]]
            // ['height', ['height']],
            // ['insert',['link']]
        ],
        defaultFontName: 'Open Sans',
        height: 138,
        disableDragAndDrop: true,
        disableResizeEditor: true
    };
}
